import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';
import { Autocomplete } from '@mui/material';
import Header from '../components/Header';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { useFormik } from "formik";
import dayjs from "dayjs";
import { Paper } from '@mui/material';
import { styled } from '@mui/material';
import { Button } from '@mui/material';
import { Divider } from '@mui/material';
import { toast } from 'sonner';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { Tooltip } from '@mui/material';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import PaymentIcon from '@mui/icons-material/Payment';
import { Modal } from '@mui/material';
import { Chip } from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    borderStyle: 'groove',
    border: '3px',
    borderColor:'grey',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
    marginTop: '10px',
    minHeight:'50px',
    borderRadius:'10px'
  }));

const RequestLogistics = () => {
    const location = useLocation();
    const society_id = location.state && location.state.society_id;
    const [society_name, setSociety_name] = useState("Society");
    const [editing_mode, setEditing_mode] = useState(false);
    const [log_data, setLog_data] = useState([]);
    const [groups, setGroups] = useState([]);
    const [open, setOpen] = useState(false);
    const [hold_invoice, setHold_invoice] = useState([]);
    const [bank_accounts, setBank_accounts] = useState([]);
    const [account_id, setAccount_id] = useState(null);
    const [kpee_account_id, setKpee_account_id] = useState(null);
    const [kpee_accounts, setKpee_accounts] = useState([]);
    const [ledgers, setLedgers] = useState([]);
    const [officeItems, setOfficeItems] = useState([]);
    const [ecash, setEcash] = useState(false);

    const handleDisburseConfirmation = (id) => {
        setAccount_id(id)
        setEcash(true)
    }

    // const officeItems = [
    //     'Tablet',
    //     'Small Phone',
    //     'Tablet Screen Protector',
    //     'Tablet Book Cover',
    //     'Laptop',
    //     'Monitor',
    //     'Keyboard',
    //     'Mouse',
    //     'Headphones',
    //     'Charger',
    //     'USB Cable',
    //     'Notebook',
    //     'Pen',
    //     'Stapler',
    //     'Paper Clips',
    //     'Folder',
    //     'Envelope',
    //     'Printer Ink',
    //     'Desk Organizer',
    //     'Plastic Savings Box',
    //     'Passbooks',
    //     'Data Books',
    //     'WIFI Router',
    //     'Stickers'
    //   ];

    const handleConfirmDisburse = () => {
        const data = new FormData();
        data.append("invoice_id", hold_invoice.id);
        if(ecash){
            data.append("ecash_id", account_id);
        }
        if(!ecash){
        data.append("bank_id", account_id);
        }
        data.append("kpee_account_id", kpee_account_id);

        toast.promise(
            api.post("/account/pay/invoice", data, {
                headers: {
                Authorization: "Bearer " + fetchToken(),
                },
            }),
            {
                loading: 'Transferring Funds...',
                success: (response) => {

                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `waybill_${hold_invoice.id}.pdf`;
                    document.body.appendChild(a);
                    a.click(); // Trigger the download
                    a.remove(); // Clean up
                    handleClose();
                    openSociety();
                    getData();
    
                    return "Payment completed successfully!, Waybill generated";
                },
                error: (error) => {
                    console.log(error);

                    return 'An error occurred, Please try again'
                }
            }
        )
      };

    const handleClose = () => {
        setOpen(false);
        setHold_invoice([]);
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 900,
        maxHeight: "80vh",
        minHeight: "70vh",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "7px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#555",
        },
        bgcolor: "background.paper",
        borderRadius: "7px",
        boxShadow: 24,
        p: 4,
    };


    const pay_invoice = (invoice) => {
        toast.promise(
            api.get(`/account/society/all/${society_id}`, {
                headers: {
                Authorization: "Bearer " + fetchToken(),
                },
            }),
            {
                loading: 'Loading bank accounts...',
                success: (response) => {
                    setBank_accounts(response.data); 
                    setOpen(true)
                    setHold_invoice(invoice)
                    return 'Loaded Successfully'
                },
                error: (error) => {
                    console.log(error);

                    return 'An error occurred, Please try again'
                }
            }
        )
    }


    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });


    const generate_waybill = (invoice_id, tag) => {
        toast.promise(
            api.get(`/association/generate/waybill/logistic/data/${invoice_id}`, {
                headers: {
                    Authorization: "Bearer " + fetchToken(),
                },
                responseType: 'blob', // Set the response type to 'blob'
            }),
            {
                loading: "Generating Receipt...",
    
                success: (response) => {
                     // Create a URL for the blob
                     const url = window.URL.createObjectURL(new Blob([response.data]));
                     const a = document.createElement('a');
                     a.href = url;
                     a.download = `receipt_${tag}.pdf`; 
                     document.body.appendChild(a);
                     a.click(); // Trigger the download
                     a.remove(); // Clean up
     
                     return "Receipt generated successfully!";
                },
                error: (error) => {
                    console.error("Error generating Receipt:", error);
                    return "Failed to generate receipt. Please try again.";
                },
            }
        );
    }

    const generateInvoice = (invoice_id, tag) => {
        toast.promise(
            api.get(`/association/generate/invoice/logistic/data/${invoice_id}`, {
                headers: {
                    Authorization: "Bearer " + fetchToken(),
                },
                responseType: 'blob', // Set the response type to 'blob'
            }),
            {
                loading: "Generating Invoice...",
    
                success: (response) => {
                     // Create a URL for the blob
                     const url = window.URL.createObjectURL(new Blob([response.data]));
                     const a = document.createElement('a');
                     a.href = url;
                     a.download = `invoice_${tag}.pdf`; // Use invoice_id instead of invoice.id
                     document.body.appendChild(a);
                     a.click(); // Trigger the download
                     a.remove(); // Clean up
     
                     return "Invoice generated successfully!";
                },
                error: (error) => {
                    console.error("Error generating invoice:", error);
                    return "Failed to generate invoice. Please try again.";
                },
            }
        );
    };

    const openSociety = () => {
        toast.promise(
          api.get(`/association/get/kpee/society/logistic/data/${society_id}`, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }),
          {
            loading: "Loading...",
            success: (response) => {
              setGroups(response.data.groups);
              setKpee_accounts(response.data.kpee_accounts);
              setLedgers(response.data.ledgers)
    
              return "Data Loaded Successfully";
            },
            error: (error) => {
              console.log(error);
    
              return "Error, Please Refresh page";
            },
          }
        );
        
        toast.promise(
          api.get('/association/get/all/items', {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }),
          {
            loading: "Loading...",
            success: (response) => {
                setOfficeItems(response.data);
              
                return "Data Loaded Successfully";
            },
            error: (error) => {
              console.log(error);
    
              return "Error, Please Refresh page";
            },
          }
        );
      };

    const editLog = (item) => {
        setEditing_mode(true);
        formik.setFieldValue('log_name', item.log_name)
        formik.setFieldValue('item_id', item.item_id)
        formik.setFieldValue('qty', item.qty)
        formik.setFieldValue('req_date', item.req_date)
        formik.setFieldValue('log_id', item.id)
        formik.setFieldValue('ledger_id', item.ledger)
        toast.info('Setup ready!! Edit in request from.')
    }

    


    const getData = () => {
        toast.promise(
            api
                .get(`/association/get/society/logistic/data/${society_id}`, {
                    headers: {
                    Authorization: "Bearer " + fetchToken(),
                    },
                }),
                {
                    loading: "Loading...",
                    success: (response) => {
                        setLog_data(response.data.data);

                        return 'Data Loaded Successfully'
                    },
                    error: (error) => {
                        console.log(error);

                        return 'Error, Please Refresh page'
                    }
                }
        )

        api
          .get(`/investors/society/get/name/${society_id}`, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            setSociety_name(response.data);
          })
          .catch(function (error) {
            console.log(error);
          });
    }

    useEffect(() => {
        if(society_name === "Society"){
          getData();
          openSociety();
        }
    }, []);


      const formik = useFormik({
        initialValues: {
          item_id: "",
          log_name: "",
          qty: null,
          req_date: dayjs(),
          log_id: null,
          ledger: null
        },
        onSubmit: (values) => {
          const data = new FormData();
          data.append("society_id", society_id);
          data.append("log_name", values.log_name);
          data.append("qty", values.qty);
          data.append("req_date", values.req_date);
          data.append("ledger", values.ledger);
          data.append("item_id", values.item_id);
          
          if(values.ledger){
            data.append("ledger", values.ledger);
          }

          if(editing_mode){
            data.append("log_id", values.log_id);
          }
          
        
        toast.promise(
            api
            .post(
              "/association/save/logistic/request",
              data,
              {
                headers: {
                  Authorization: "Bearer " + fetchToken(),
                  "Content-Type": "multipart/form-data",
                },
              }
            ),
            {
                loading: !editing_mode?'Creating request...': 'Editing request...',
                success: (response) => {
                    setEditing_mode(false);
                    formik.handleReset();
                    getData();
                    return response.data
                },
                error: (error) => {
                    console.log(error);
                    
                    return 'Error, Please try again'
                }
            }
        )
        },
      });


      function formatDateToYearMonthDay(date) {
        const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = "th";

        if (day === 1 || day === 21 || day === 31) {
        suffix = "st";
        } else if (day === 2 || day === 22) {
        suffix = "nd";
        } else if (day === 3 || day === 23) {
        suffix = "rd";
        }

        return `${day}${suffix} ${month} ${year}`;
    }

    const deleteLog = (id) => {
        toast.promise(
            api
                .delete(`/association/delete/society/logistic/data/${id}`, {
                    headers: {
                    Authorization: "Bearer " + fetchToken(),
                    },
                }),
                {
                    loading: "Deleting request...",
                    success: (response) => {
                        getData();
                        return response.data
                    },
                    error: (error) => {
                        console.log(error);

                        return 'Error, Please Refresh page'
                    }
                }
        )
    }


  return (
    <div className="app">
        <main className="content">
            <Box sx={{ m: 5 }}>
                {/* HEADER */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                <Header
                    title="Request For Logistics"
                />
                </Box>
                <Box>
                    <Typography
                        variant="h3"
                        sx={{ textAlign: "center", m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>{society_name}</b>
                    </Typography>
                </Box>
                {/* main content */}
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Item>
                            <Typography
                                variant="h5"
                                sx={{ textAlign: "center", m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                                <b>Request Form {editing_mode?'(Editing request)':null}</b>
                            </Typography>

                            <Autocomplete
                                id="tags-outlined"
                                options={officeItems}
                                size="small"
                                sx={{ mt: 2 }}
                                getOptionLabel={(option) => option.item_name}
                                isOptionEqualToValue={(option, value) =>
                                    option.item_name === value.id
                                }
                                onChange={(event, value) => {
                                        formik.setFieldValue("log_name", value.item_name)
                                        formik.setFieldValue("item_id", value.id)
                                    }
                                }
                                filterSelectedOptions
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    name="log_name"
                                    placeholder="Tablet"
                                    helperText="Item"
                                    fullWidth
                                />
                                )}
                            />
                            <TextField
                                sx={{ m:1 }}
                                size="small"
                                name="qty"
                                type='number'
                                value={formik.values.qty}
                                onChange={formik.handleChange}
                                placeholder="100"
                                helperText="Quantity"
                                fullWidth
                            />
                            <TextField
                                sx={{ m:1 }}
                                size="small"
                                name="req_date"
                                type='datetime-local'
                                value={formik.values.req_date}
                                onChange={formik.handleChange}
                                disabled={editing_mode}
                                helperText="Request Date"
                                fullWidth
                            />

                            <Autocomplete
                                id="tags-outlined"
                                options={ledgers}
                                sx={{ mt: 2 }}
                                getOptionLabel={(option) => option.account_name}
                                isOptionEqualToValue={(option, value) =>
                                    option.account_name === value.id
                                }
                                onChange={(event, value) =>
                                    formik.setFieldValue("ledger", value.id)
                                }
                                filterSelectedOptions
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    helperText="Expense Account"
                                    size="small"
                                    fullWidth
                                />
                                )}
                            />

                            <Box sx={{ display:'flex', flexDirection:'row' }}>
                                <Button
                                    size="small"
                                    color="error"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    m: 1,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={formik.handleReset}
                                >
                                    Close
                                </Button>

                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    m: 1,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={formik.handleSubmit}
                                    disabled={!formik.values.log_name || !formik.values.qty || !formik.values.ledger}
                                >
                                    {editing_mode ? "Edit Request" : "Create Request"}
                                </Button>
                            </Box>
                        </Item>
                    </Grid>
                     {/* track current log group */}
                    <Grid item xs={12} md={8}>
                    <Item>
                            <Typography variant="h4" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                                <b>Forms</b>
                            </Typography>
                            <Box
                                sx={{
                                overflow: "auto",
                                marginBottom: 10,
                                maxHeight: 340,
                                "&::-webkit-scrollbar": {
                                    width: "7px",
                                    height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                    background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    background: "#888",
                                    borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                    background: "#555",
                                },
                                }}
                            >
                                {!groups[0] ? (
                                <Typography
                                    sx={{ m: 1 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>No Forms Available</b>
                                </Typography>
                                ) : null}

                                <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Tag</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Items(No.)</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Quantity</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Amount</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Status</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Invoice</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Pay Invoice</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Receipt</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {groups?.map((row, index) => (
                                    <TableRow
                                        key={row.index}
                                        sx={{
                                        "&:last-child td, &:last-child th": {
                                            border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                        }}
                                    >
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>#{row.tag}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.total_logs}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.total_quantity}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{currencyFormat.format(row.total_amount)}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.status}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                size="small"
                                                color="success"
                                                variant="contained"
                                                sx={{
                                                borderRadius: 2,
                                                boxShadow:
                                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                "&:hover": {
                                                    boxShadow:
                                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                    backgroundColor: "#14213d",
                                                },
                                                }}
                                                onClick={() => generateInvoice(row.id, row.tag)}
                                            >
                                                <ReceiptRoundedIcon />
                                            </Button> 
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                    size="small"
                                                    color="success"
                                                    variant="contained"
                                                    disabled={row.status === "Payment Complete"}
                                                    sx={{
                                                    borderRadius: 2,
                                                    boxShadow:
                                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow:
                                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                    }}
                                                    onClick={() => pay_invoice(row)}
                                                >
                                                    <PaymentIcon />
                                                </Button> 
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                size="small"
                                                color="success"
                                                variant="contained"
                                                disabled={row.status !== "Payment Complete"}
                                                sx={{
                                                borderRadius: 2,
                                                boxShadow:
                                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                "&:hover": {
                                                    boxShadow:
                                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                    backgroundColor: "#14213d",
                                                },
                                                }}
                                                onClick={() => generate_waybill(row.id, row.tag)}
                                            >
                                                <PaidIcon />
                                            </Button>
                                        </Typography>
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>
                                </Table>
                            </Box>
                        </Item>
                    </Grid>
                    {/* logs list */}
                    <Grid item xs={12} md={12}>
                        <Box
                            sx={{
                            overflow: "auto",
                            marginBottom: 10,
                            maxHeight: 340,
                            "&::-webkit-scrollbar": {
                                width: "7px",
                                height: "7px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                            },
                            }}
                        >
                            {!log_data? <Typography sx={{m:1}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>No History, Use the form above to create a new request</b>
                            </Typography>:null}

                            <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>No.</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Request Date</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Logistic</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Quantity</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Status</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Edit</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Delete</b>
                                        </Typography>{" "}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {log_data?.map((row, index) => (
                                    <TableRow
                                        key={row.index}
                                        sx={{
                                            "&:last-child td, &:last-child th": { border: 0 },
                                            backgroundColor: "#f5f3f4",
                                        }}
                                    >
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{index + 1}</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{formatDateToYearMonthDay(new Date(row.req_date))}</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                                {row.log_name}
                                            </b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{row.qty}</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.status}</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <Button
                                                    size="small"
                                                    color="success"
                                                    variant="contained"
                                                    sx={{
                                                    borderRadius: 2,
                                                    boxShadow:
                                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow:
                                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                    }}
                                                    onClick={() => editLog(row)}
                                                >
                                                    <EditNoteRoundedIcon />
                                                </Button> 
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <Tooltip title="This action can not be undone">
                                                    <Button
                                                        size="small"
                                                        color="error"
                                                        variant="contained"
                                                        sx={{
                                                        borderRadius: 2,
                                                        boxShadow:
                                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                        "&:hover": {
                                                            boxShadow:
                                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                            backgroundColor: "#14213d",
                                                        },
                                                        }}
                                                        onClick={() => deleteLog(row.id)}
                                                    >
                                                        <DeleteRoundedIcon />
                                                    </Button>
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        </Box>
                    </Grid>

                </Grid>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography sx={{textAlign:'center'}}  variant="h4" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Pay Invoice</b>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                        Amount to Pay: {currencyFormat.format(hold_invoice.total_amount)}
                                    </b>
                                </Typography>
                                <Box>
                                    <Typography
                                        variant="h6"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                        <b>Select bank account to pay invoice TO</b>
                                    </Typography>

                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                        {kpee_accounts.map((item) => (
                                            <Chip
                                                key={item.id}
                                                label={
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b> {item.account_name} | {item.account_provider} | {item.account_number} </b>
                                                    </Typography>
                                                }
                                                onClick={() => setKpee_account_id(item.id)}
                                                variant="outlined"
                                                sx={{
                                                    borderRadius: 2,
                                                    m: 1,
                                                    boxShadow:
                                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    backgroundColor: kpee_account_id === item.id? "green": "#fff",
                                                    color:  kpee_account_id === item.id? "#fff": "#000",
                                                    "&:hover": {
                                                    boxShadow:
                                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                    },
                                                }}
                                            />
                                        ))}
                                    </div>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Divider variant="middle" sx={{ m:1 }}/>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Typography
                                    variant="h6"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>Select account to pay invoice from</b>
                                </Typography>

                                <Chip
                                    disabled={
                                        hold_invoice.total_amount < bank_accounts?.Main?.current_balance
                                        ? false
                                        : true
                                    }
                                    label={`Main Wallet Account ==> ${currencyFormat.format(bank_accounts?.Main?.current_balance)}`}
                                    onClick={() => handleDisburseConfirmation(bank_accounts?.Main?.id)}
                                    variant="outlined"
                                    color="success"
                                    style={{ margin: "4px" }}
                                    />
                                    
                                    <Divider sx={{my:1}} variant="middle">
                                    <Typography
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                        <b>Other Accounts</b>
                                    </Typography>
                                    </Divider>
                                <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    {bank_accounts?.Accounts?.map((item) => (
                                        <Chip
                                            disabled={hold_invoice.total_amount < item.current_balance? false: true}
                                            key={item.id}
                                            label={
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>{item.account_name}: {currencyFormat.format(item.current_balance)}</b>
                                                </Typography>
                                            }
                                            onClick={() => setAccount_id(item.id)}
                                            variant="outlined"
                                            sx={{
                                                borderRadius: 2,
                                                m: 1,
                                                boxShadow:
                                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                backgroundColor: account_id === item.id? "green": "#fff",
                                                color:  account_id === item.id? "#fff": "#000",
                                                "&:hover": {
                                                  boxShadow:
                                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                },
                                              }}
                                        />
                                    ))}
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Box sx={{ display:'flex', flexDirection:'row' }}>
                                    <Button
                                        size="small"
                                        color="error"
                                        variant="contained"
                                        sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                        },
                                        }}
                                        onClick={handleClose}
                                    >
                                        Close
                                    </Button>

                                    <Button
                                        size="small"
                                        color="success"
                                        variant="contained"
                                        sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                        },
                                        }}
                                        onClick={handleConfirmDisburse}
                                        disabled={account_id && kpee_account_id ? false : true}
                                    >
                                        Complete Payment
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            </Box>
        </main>
    </div>
  )
}

export default RequestLogistics